import { templateService } from '@/services'

export default {
  state: () => ({
    templates: [],
    activeState: 'All',
    showModal: false,
    showAside: false
  }),

  getters: {
    hasTemplates (state) {
      return state.templates.length > 0
    }
  },

  mutations: {
    toggleTemplateModal (state, value) {
      state.showModal = value
    },

    changeTemplateState (state, value) {
      state.activeState = value
    },

    toggleTemplateAside (state, value) {
      state.showAside = value
    },

    setTemplates (state, value) {
      state.templates = value
    },

    updateTemplate (state, { id, data }) {
      const templates = state.templates.map(item => {
        if (item.id === id) {
          return {
            ...item,
            ...data
          }
        }
        return item
      })

      state.templates = templates
    },

    deleteTemplate (state, id) {
      const templates = state.templates.filter(item => item.id !== id)

      state.templates = templates
    }
  },

  actions: {
    getTemplates ({ commit }, type) {
      return templateService.getAll({ type })
        .then(res => commit('setTemplates', res.data.templates))
    },

    createTemplate ({ commit, state }, formData) {
      return templateService.add(formData)
        .then(res => {
          const templates = state.templates
          templates.push(res.data.template)

          commit('setTemplates', templates)
        })
    },

    updateTemplate ({ commit }, { id, title, isShared }) {
      return templateService.update({ id, title, isShared })
        .then(_ => {
          commit('updateTemplate', {
            id,
            data: {
              title,
              teamId: isShared
            }
          })
        })
    },

    deleteTemplate ({ commit }, id) {
      return templateService.delete(id)
        .then(_ => commit('deleteTemplate', id))
    },

    orderTemplates (_, { ids }) {
      return templateService.order(ids)
    }
  }
}
